import ACTION_ITEMS from '../actionItems';

export function setSelectedSkill(skill) {
  return {
    type: ACTION_ITEMS.PROJECT_BUILDER.SELECTED_SKILL.SET,
    payload: skill,
  };
}
